'use strict';
//signalrService MIGRADO
angular.module('TurneroApp').component('coAtencion', {
    bindings: {
        centroAtencionSeleccionado: '<'
    },
    controller: [
        'agendaService',
        'puestosService',
        'utilsService',
        'usuariosService',
        '$localStorage',
        'signalrDotNetCoreService',
        'TurneroAppConstant',
        function (agendaService, puestosService, utilsService, usuariosService, $localStorage, signalrService, TurneroAppConstant) {
            var ctrl = this;
            ctrl.Atencion = null;
            ctrl._inicializado = false; // Flag para evitar inicialización duplicada

            //ctrl.Signalr = signalrService;
            ctrl.disconnectSignalr = function () {
                //signalrService.disconnect();
                //signalrService.stopHub(TurneroAppConstant.HubNames.PUESTOS); <-Esto dependiendo el sincronismo me cierra ANTES DE TIEMPO la conexión...
            }
            
            // Función para inicializar/restaurar la sesión
            ctrl.inicializarAtencion = function () {
                // Evitar inicialización duplicada
                if (ctrl._inicializado) return;
                ctrl._inicializado = true;
                // Verificar si existe una sesión activa desde el sidebar
                if ($localStorage.TurneroApp_UsuarioSesion && $localStorage.TurneroApp_UsuarioSesion.Id_Usuario_Sesion) {
                    ctrl.restaurarSesionSidebar();
                } else {
                    ctrl.limpiarMemoria();
                }
            };

            //el onChange se ejecuta cada vez que cambian los parametros del binding 
            ctrl.$onChanges = function () {
                // Obtener centro de atención desde binding o localStorage
                if (!ctrl.centroAtencionSeleccionado || !ctrl.centroAtencionSeleccionado.id) {
                    if ($localStorage.centroAtencionSeleccionado && $localStorage.centroAtencionSeleccionado.id) {
                        ctrl.centroAtencionSeleccionado = $localStorage.centroAtencionSeleccionado;
                    }
                }
                
                if (ctrl.centroAtencionSeleccionado && ctrl.centroAtencionSeleccionado.id) {
                    ctrl.inicializarAtencion();
                }
            };
            
            // También inicializar en $onInit para cuando se carga directamente desde una URL
            ctrl.$onInit = function () {
                // Si no se recibió centro por binding, intentar obtenerlo de localStorage
                if (!ctrl.centroAtencionSeleccionado || !ctrl.centroAtencionSeleccionado.id) {
                    if ($localStorage.centroAtencionSeleccionado && $localStorage.centroAtencionSeleccionado.id) {
                        ctrl.centroAtencionSeleccionado = $localStorage.centroAtencionSeleccionado;
                        ctrl.inicializarAtencion();
                    }
                }
            };

            // Restaurar sesión activa desde el sidebar
            ctrl.restaurarSesionSidebar = function () {
                ctrl.UsuarioConfig = $localStorage.TurneroApp_UsuarioSesion;
                ctrl.PuestoSeleccionado = $localStorage.PuestoSeleccionado || ctrl.UsuarioConfig.Puesto;
                
                // Restaurar agenda (manejar el caso de 0 = "Todas mis agendas")
                var agendaGuardada = $localStorage.AgendaSeleccionada;
                var agendaRestaurada = (agendaGuardada !== undefined && agendaGuardada !== null) ? agendaGuardada : null;
                
                ctrl.Atencion = {
                    Agenda: agendaRestaurada,
                    Atencion: null,
                    Puesto: ctrl.PuestoSeleccionado
                };

                // Obtener puestos para mostrar el combo
                ctrl.getPuestos();

                // Obtener agendas para el usuario
                agendaService.Get_Agendas_Combo_Atencion({ 
                    'id_centro_usuario': ctrl.UsuarioConfig.Id_Centro_Usuario 
                }).$promise.then(function (resultado) {
                    ctrl.Agendas = resultado.Data;
                    
                    // Si ya había una agenda seleccionada, restaurarla (manejar 0 para "Todas mis agendas")
                    if (agendaGuardada !== undefined && agendaGuardada !== null) {
                        if (agendaGuardada === 0) {
                            // "Todas mis agendas"
                            ctrl.Atencion.Agenda = 0;
                        } else if (agendaGuardada && agendaGuardada.id) {
                            // Buscar la agenda en el array para obtener la referencia correcta
                            var agendaEncontrada = ctrl.Agendas.find(function(agenda) {
                                return agenda.id == agendaGuardada.id;
                            });
                            if (agendaEncontrada) {
                                ctrl.Atencion.Agenda = agendaEncontrada;
                            }
                        }
                    }
                }).catch(function (error) {
                    utilsService.errores(error);
                });
            };

            ctrl.limpiarMemoria = function () {
                ctrl.Atencion = {
                    Agenda: null,
                    Atencion: null
                };
                //este codigo elimina del localstorage el id_usuario_sesion
                delete ($localStorage.TurneroApp_UsuarioSesion)
                //cada vez que se limpia la pantalla se obtienen los puestos, para refrescar el estado de los mismos
                ctrl.getPuestos();
                ctrl.Agendas = null;
                ctrl.Turnos = null;
            }

            //LOGIN Y LOGOUT 
            ctrl.getPuestos = function () {
                //Obtiene los puestos de atencion que estan cargados para ese centro de atencion y tambien retorna los centro usuario para saber si esta logueado un usuario (Ocupado),
                //si el puesto esta asignado al usuario (Mi Puesto), o si esta libre.
                puestosService.Get_Puestos_Combo_Atencion({
                    'id_centro_atencion': ctrl.centroAtencionSeleccionado.id
                }).$promise.then(function (resultado) {
                    ctrl.Puestos = resultado.Data;
                }).catch(function (error) {
                    //Si ocurre un error limpia todo.
                    utilsService.errores(error, function () {
                        ctrl.Atencion.Puesto = null;
                    });
                });
            }

            ctrl.getAgendas = function (puesto) { //Obtengo las agendas para el usuario logueado para este centro de atencion.
                ctrl.Agendas = null;
                ctrl.Atencion.Agenda = null;
                var UsuarioLogueado = false;

                for (var i = 0; i < ctrl.Puestos.length; i++) { //verifica que el usuario no se encuentre logueado en otro puesto 
                    if (puesto.Id_Centro_Usuario == ctrl.Puestos[i].Id_Centro_Usuario_Puesto) {
                        UsuarioLogueado = true;
                    }
                }

                if (puesto) {
                    if (puesto.Id_Centro_Usuario != puesto.Id_Centro_Usuario_Puesto && UsuarioLogueado) { //si el puesto seleccionado no tiene mi mismo Id_Centro_Usuario y estoy logueado en otro puesto
                        swal({
                            title: 'Atención',
                            html: 'Actualmente existe un puesto logueado con su usuario. <br/> ¿Esta seguro que desea loguearse en otro puesto de atención?',
                            type: 'info',
                            showCancelButton: true,
                            confirmButtonColor: '#004b81',
                            cancelButtonColor: '#971b2f',
                            confirmButtonText: "Sí",
                            cancelButtonText: "No",
                            allowEscapeKey: false,
                            allowOutsideClick: false
                        }).then(function () {
                            //Si se selecciono si, se ejecuta el inicio de sesion, que cierra la sesion anterior y crea un nuevo Id_usuario_sesion
                            ctrl.iniciar_Sesion(puesto);

                        }, function (error) {
                            //hubiera un error o se cierra el modal, por alguna cuestion se limpia el puesto y vuelve al inicio.
                            swal.close();
                            ctrl.Atencion.Puesto = null;

                        })
                    } else {

                        ctrl.iniciar_Sesion(puesto);
                    }
                }
            };

            ctrl.iniciar_Sesion = function (puesto) {
                //Se crea el Usuario Sesion para el usuario, para el Puesto.
                usuariosService.Post_Usuario_Sesion_Atencion({
                    'id_centro_atencion': parseInt(ctrl.centroAtencionSeleccionado.id),
                    'id_puesto': parseInt(puesto.id)
                }).$promise.then(function (resultado) {
                    //se obtienen lospuestos de nuevo para cambiar los estados de los puestos
                    ctrl.getPuestos();
                    ctrl.PuestoSeleccionado = puesto;

                    //Se guardan en el localstorage la informacion que viene desde la db /*EJEMPLO : {"Id_Usuario_Sesion":1187620,"Id_Centro_Usuario":14262,"Puesto":{"Id_Centro_Usuario_Puesto":"","Id_Centro_Usuario":"14262","Id_Padre":"","id":"661","text":"Puesto de Prueba 3"},"Solo_Llamar_Proximo":false,"Llamador_Activo":true}*/
                    $localStorage.TurneroApp_UsuarioSesion = resultado.Data;
                    $localStorage.TurneroApp_UsuarioSesion.Puesto = ctrl.PuestoSeleccionado;
                    ctrl.UsuarioConfig = $localStorage.TurneroApp_UsuarioSesion;

                    //SIGNALR : En este metodo se llama al PuestoHub , y se invoca al metodo TRAERPUESTOS. este metodo lo que hace es refrescar la lista de puestos de 'Estado Puesto de Salon'
                    signalrService.startHub(TurneroAppConstant.HubNames.PUESTOS).then(function (hub) {
                        hub.invoke('TraerPuesto', ctrl.centroAtencionSeleccionado.id, puesto.id).then(function () {
                            console.info("Se invocó a TraerPuesto en " + TurneroAppConstant.HubNames.PUESTOS + ".");
                        }).catch(function (err) {
                            console.error("Falló invocación a TraerPuesto en " + TurneroAppConstant.HubNames.PUESTOS + ": " + err.toString());
                        });
                    });

                    //obtengo las agendas, para el usuario
                    agendaService.Get_Agendas_Combo_Atencion({ 'id_centro_usuario': ctrl.UsuarioConfig.Id_Centro_Usuario }).$promise.then(function (resultado) {
                        ctrl.Agendas = resultado.Data;
                    }).catch(function (error) {
                        utilsService.errores(error);
                    });
                }).catch(function (error) {
                    utilsService.errores(error, ctrl.getPuestos);
                });
            }

            ctrl.muestraTurnoDetalle = function (bool) {
                //esta variable es utilizada para mostrar la grilla u ocultarla, en el caso de ocultarla se muestra el detalle del turno (para el estado atendido)
                ctrl.turnoDetalles = bool;
            }

            ctrl.postMovimientosAgenda = function (agenda) {
                //se ejecuta cuando el usuario seleciciona alguna agenda
                // Post Movimiento registra en que agenda va a estar trabajando el usuario logueado. 
                // Si el Usuario Seleccionado todas las Agendas se envia "agenda" = 0 sino se envia el objeto de la agenda y en el post se envia el Id de la agenda.
                if (agenda || agenda == 0) {
                    var auxIDagenda = agenda == 0 ? 0 : parseInt(agenda.id);
                    var aux = ctrl.UsuarioConfig;
                    ctrl.UsuarioConfig = null;

                    //ctrl.turnosEnEspera es un metodo que esta definido en el componente atencionListadoComponent 
                    if (ctrl.turnosEnEspera)
                        ctrl.turnosEnEspera(auxIDagenda);

                    usuariosService.Post_Movimiento_Usuario_Sesion({
                        'id_usuario_sesion': aux.Id_Usuario_Sesion,
                        'id_centro_usuario': aux.Id_Centro_Usuario,
                        'id_agenda': agenda == 0 ? null : agenda.id,
                        'id_centro_atencion': parseInt(ctrl.centroAtencionSeleccionado.id)
                    }).$promise.then(function (resultado) {
                        aux.Solo_Llamar_Proximo = resultado.Data.Llamar_Proximo == 'S' ? true : false;
                        aux.Llamador_Activo = resultado.Data.Llamador_Activo ? true : false;
                        aux.Id_Agenda = auxIDagenda;

                        ctrl.UsuarioConfig = aux;//Dispara el $onChanges en el componente de la grilla
                        ctrl.muestraTurnoDetalle(false);
                    }).catch(function (error) {
                        utilsService.errores(error);
                        if (error.data && error.data.IsUserSessionException) {
                            ctrl.limpiarMemoria();
                        } else {
                            ctrl.UsuarioConfig = aux;
                        }
                    })
                }
            }

            ctrl.getAgendaReferenciaTurno = function (turno) {
                // Id_Agenda viene de ID_ULTIMA_AGENDA_GET y refleja la ultima derivacion.
                // Agenda_Destino_Deriv puede quedar desactualizada en cadenas de derivaciones.
                if (turno.Id_Agenda && turno.Id_Agenda > 0)
                    return turno.Id_Agenda;

                if (turno.Agenda_Destino_Deriv && turno.Agenda_Destino_Deriv > 0)
                    return turno.Agenda_Destino_Deriv;

                return turno.Id_Agenda;
            };

            ctrl.validarAgendaTurno = function (turno) {
                var agendaReferencia = ctrl.getAgendaReferenciaTurno(turno);

                if (!agendaReferencia || agendaReferencia <= 0)
                    return false;

                //si selecciono todas las agendas
                if (ctrl.Atencion.Agenda == 0) {
                    return ctrl.Agendas.findIndex(x => x.id == agendaReferencia) != -1;
                }
                //si tiene una agenda seleccionada
                else if (ctrl.Atencion.Agenda) {
                    return agendaReferencia == ctrl.Atencion.Agenda.id;
                }
                else
                    return false
            }

            ctrl.validarAgendaTurnoDerivado = function (turno) {
                return ctrl.validarAgendaTurno(turno);
            }
        }],
    template: require('./atencion.html')
});



// WEBPACK FOOTER //
// ./app/components/atencion/atencionComponent.js